var React = require('react');
var BaseClassComponent = require('../../shared/base.jsx');

class ImageComponent extends BaseClassComponent {
    constructor(props) {
        super(props);
        let src = '/assets/images/img-placeholder.png';
        if (props.customFieldValues && props.customFieldValues.Values && props.customFieldValues.Values.length > 0 && props.customFieldValues.Values[0]) {
            src = props.customFieldValues.Values[0];
        }
        this.state = {
            fileName: '',
            src: src
        }
        this.onImageChange = this.onImageChange.bind(this);
    }

    onImageChange(e) {
        var _this = this;
        let files = e.target.files;
        this.setState({
            fileName: e.target.files[0].name
        }, () => {
                let reader = new FileReader();
                reader.onload = r => {
                    _this.props.onCustomFileChanged(_this.props.customFieldDefinition, r.target.result, _this.state.fileName);
                    _this.setState({
                        src: r.target.result
                    });
                };
                reader.readAsDataURL(files[0]);
            }
        )        
    }

    render() {
        let css = "input-upload ";
        if (this.props.customFieldDefinition.IsMandatory) {
            css += "required";
        }
        return (
            <div className="input-container">
                <div className={css}>
                    <span className="custom-image">{this.props.customFieldDefinition.Name}</span>
                    <div className="input-flex">
                        <input type="text" className="input-text custom-image-text isImage" name="custom_image" placeholder="Browse..." value={this.state.fileName} />
                        <div className="btn-upload btn" style={{ borderRadius: "0px" }}>
                            <input onChange={this.onImageChange} type="file" />
                            Upload
                        </div>
                    </div>
                    <div><img alt="" src={this.state.src} className="img-responsive imgpreview" /></div>
                </div>
            </div>
        )
    }
}

module.exports = ImageComponent;